//Component is created by nisha, a modal of add edit shipment with responsiveness

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../components/SpinContext";
import { useToken } from "../../common/helper";

// Components
import {
  Flex,
  Modal,
  Form,
  Row,
  Col,
  message,
  AutoComplete,
  Divider,
  Tooltip,
} from "antd";
import {
  CustomButton,
  CustomTitle,
  CustomDynamicSelect,
  CustomInput,
  AddItemButton,
  CustomModal,
  MapComponent,
  CustomParagraph,
  CustomSelect,
} from "../../components";
import { CreateNewShipment, GetSingleShipment } from "../../api's/shipment";
import {
  getCouriersDDL,
  getSensorsDDL,
  getProductDDL,
  getLocationDDL,
  getCompanyCouriersDDL,
  getTeamsDDL,
  getTeamsDDLOFFeature,
} from "../../common/utils/dropDown";
import { useSelector } from "react-redux";
import { GetCompanySensors } from "../../api's/settings";
import LocationAutoComplete from "../Modals/LocationAutoComplete";
import { CloseOutlined, DownOutlined } from "@ant-design/icons";
import { sensorIgnoreTime } from "../../common/static_data";
import ShipmentMap from "./ShipmentMap";
import { GoogleMapsProvider } from "../../components/GoogleMapsProvider";
import EditLocation from "../../assets/images/edit_location.svg";
import LocationAutoCompleteShipment from "../Modals/LocationAutoCompleteShipment";
import ShipmentPreviewMap from "./ShipmentPreviewMap ";
import TeamsSelector from "../../components/TeamsSelector";
import TeamsSelectorCheckbox from "../../components/TeamsSelectorCheckbox";
import CustomCheckboxGroup from "../../components/CustomCheckboxGroup";
import { useWatch } from "antd/es/form/Form";

const CreateShipmentDrawer = ({
  handleCloseDrawer,
  onShipmentSuccess,
  shipmentId,
  onSuccess,
}) => {
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const [locationList, setLocationList] = useState([]);
  const [fromLocation, setFromLocation] = useState(null);
  const [toLocation, setToLocation] = useState(null);
  const [showSensorFields, setShowSensorFields] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [couriersList, setCouriersList] = useState([]);
  const [sensorsList, setSensorsList] = useState([]);
  const [productList, setProductList] = useState([]);
  const { token, removeToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const [form] = Form.useForm();

  const [options, setOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalName, setModalName] = useState("");
  const [locationName, setLocationName] = useState("");
  const [polygonFrom, setPolygonFrom] = useState();
  const [polygonTo, setPolygonTo] = useState();

  const [selectedTeams, setSelectedTeams] = useState([]);

  const [selectedLatLng1, setSelectedLatLng1] = useState({
    lat: null,
    lng: null,
  });
  const [selectedLatLng2, setSelectedLatLng2] = useState({
    lat: null,
    lng: null,
  });

  // teams for drop down
  const teamsList = useSelector((state) => state.teams.list);

  const hasValidTeams = !(
    teamsList.length === 0 ||
    (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
  );

  const [allTeams, setAllTeams] = useState([]);
  useEffect(() => {
    getTeamsDDLOFFeature(token, "Shipment").then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });
  }, []);

  const openMapModal = (name) => {
    setLocationName(name);
    setModalOpen(true);
    setModalName("Draw Polygon");
    //setPolygonFrom(null);
  };

  const getPolygon = (val) => {
    if (val && val.length > 0) {
      if (locationName == "from_location") {
        setPolygonFrom(val);
      } else {
        setPolygonTo(val);
      }
    }
  };
  const onModalConfirm = () => {
    if (polygonFrom && polygonFrom.length > 0) {
      message.success("Polygon created");
      setModalOpen(false);
    } else {
      message.error("Please mark proper area");
    }
  };
  const handleSetModalOpen = (item) => {
    if (item == false) {
      setPolygonFrom(null);
      setModalOpen(false);
    }
  };
  const handleAddressChange = (value) => {
    if (!value) {
      setSelectedLatLng1({ lat: "", lng: "" });
    }
  };
  // Form submission handler

  const handleAddressPlaceSelect = (place, fieldName) => {
    const lat = place?.latitude;
    const lng = place?.longitude;
    if (fieldName === "from_location") {
      setSelectedLatLng1({ lat: lat, lng: lng });
      setFromLocation(place);
    } else if (fieldName === "to_location") {
      setSelectedLatLng2({ lat: lat, lng: lng });
      setToLocation(place);
    }
    form.setFieldsValue({
      [fieldName]: `${place.placeName || place.name}`,
    });
  };

  //get single shipment by shipment id
  useEffect(() => {
    if (shipmentId) {
      //  GetSingleShipmentById(shipmentId)
    }
  }, [shipmentId]);

  const GetSingleShipmentById = (id) => {
    showSpin();
    GetSingleShipment(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              form.setFieldsValue({
                courier: resp?.courier?.id || null,
                courier_tracking_id: resp?.courier_tracking_id || null,
                sensor: resp?.sensor?.id || null,
                sensor_tracking_id: resp?.sensor_tracking_id || null,
                reference_number: resp?.reference_number || null,
                id: resp?.id || null,
                product: resp?.product?.id || null,
                from_location: resp?.from_location?.id || null,
                to_location: resp?.to_location?.id || null,
              });
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  //Making dropdwon Calls for transport providers

  useEffect(() => {
    getCompanyCouriersDDL(token).then((val) => {
      if (val && val.length > 0) {
        setCouriersList(val);
      }
    });
  }, []);

  useEffect(() => {
    GetCompanySensors(token).then((res) => {
      const data = res?.data || null;
      if (data) {
        if (data.data?.is_success) {
          if (data.data.data && data.data.data.length > 0) {
            setSensorsList(data.data.data);
          }
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  }, []);

  useEffect(() => {
    getProductDDL(token).then((val) => {
      if (val && val.length > 0) {
        setProductList(val);
      }
    });
  }, []);

  useEffect(() => {
    getLocationDDL(token).then((val) => {
      if (val && val.length > 0) {
        setLocationList(val);
        console.log(val,'asdasds')
      }
    });
  }, []);

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = { ...values };
      model.id = null;
      const teamIDs = model.teams?.map((item) => item?.id);
      model.teams = teamIDs;
      if (fromLocation) {
        if (fromLocation.id && fromLocation.id !== undefined) {
          model.from_location = {
            ...fromLocation,
            polygon: polygonFrom && polygonFrom.length > 0 ? polygonFrom : [],
          };
        } else {
          model.from_address = fromLocation.placeName;
          delete model.from_location;
        }
      }

      if (toLocation) {
        if (toLocation.id && toLocation.id !== undefined) {
          model.to_location = {
            ...toLocation,
            polygon: polygonTo && polygonTo.length > 0 ? polygonTo : [],
          };
        } else {
          model.to_address = toLocation.placeName;
          delete model.to_location;
        }
      }

      console.log("Final model sent to API to track new shipment:", model);

      if (!model.sensor && !model.courier) {
        message.error(
          "At least one of sensor or transport provider must be filled"
        );
        return;
      }

      if (ignoreSensorAlerts?.length === 0) {
        model.ignore_sensor_measurement_at_start = null;
      }


      submitShipment(model);
    }
  };
  const sensorValue = useWatch("sensor", form);
  useEffect(() => {
    if (!showSensorFields) {
      form.setFieldsValue({
        sensor_tracking_id: undefined,
        sensor: undefined,
      });
    } else {
      form.setFields([{ name: "sensor_tracking_id", errors: [] }]);
      form.setFields([{ name: "sensor", errors: [] }]);
    }
  }, [showSensorFields]);

  const onFormValueCahnges = () => {
    if (
      !form.getFieldValue("sensor_tracking_id") &&
      !form.getFieldValue("sensor")
    ) {
      form.setFields([{ name: "sensor_tracking_id", errors: [] }]);
      form.setFields([{ name: "sensor", errors: [] }]);
    }
    if (
      !form.getFieldValue("courier_tracking_id") &&
      !form.getFieldValue("courier")
    ) {
      form.setFields([{ name: "courier_tracking_id", errors: [] }]);
      form.setFields([{ name: "courier", errors: [] }]);
    }
    // from location
    if (!form.getFieldValue("from_location")) {
      setFromLocation(null);
    }
    // to location
    if (!form.getFieldValue("to_location")) {
      setToLocation(null);
    }
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const submitShipment = (model) => {
    setIsFormValid(true);
    showSpin();
    CreateNewShipment(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            handleCloseDrawer();
            onSuccess(data?.data?.data)
            //  onShipmentSuccess();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  const [ignoreSensorAlerts, setIgnoreSensorAlerts] = useState([]);

  return (
    <>
      <Form
        form={form}
        name="CreateNewShipment"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        onValuesChange={onFormValueCahnges}
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            padding: "0px 32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={"Track new shipment"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>

        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "140px",
            paddingTop: "18px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[0, 16]}>
            {/* <Col span={24}>
              <CustomTitle
                text={"Transport provider"}
                fontSize={15}
                fontWeight="600"
                lineHeight="20px"
                color="#000"
                marginBottom={0}
              />
            </Col> */}
            {/* tracking ID */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Transport provider Tracking ID"
                name="courier_tracking_id"
                rules={[
                  {
                    required: false,
                    message: "Please enter transport provider tracking ID",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim() === "") {
                        return Promise.reject(
                          new Error("Only spaces are not allowed")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("courier") && !value) {
                        return Promise.reject(
                          new Error(
                            "Please enter transport provider tracking ID"
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <CustomInput
                  placeholder="Paste tracking number"
                  height="36px"
                  width="100%"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#000"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* Transport provider */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Transport provider"
                name="courier"
                rules={[
                  {
                    required: false,
                    message: "Please select transport provider",
                  },

                  ({ getFieldValue }) => ({
                    validator: (_, value) => {
                      if (getFieldValue("courier_tracking_id") && !value) {
                        return Promise.reject(
                          new Error("Please select transport provider")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <CustomDynamicSelect
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  placeholder="Select"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#000"
                  borderRadius="8px"
                  options={couriersList}
                  label="courier_name"
                  isCourier={true}
                  allowClear={true}
                />
              </Form.Item>
            </Col>

            <Divider style={{ margin: "0px" }} />

            {/* Sensors */}

            {!showSensorFields ? (
              <>
                {/* <Col span={24}>
                  <CustomTitle
                    text={"Sensor"}
                    fontSize={15}
                    fontWeight="600"
                    lineHeight="20px"
                    color="#000"
                    marginBottom={0}
                  />
                </Col> */}
                <Col span={24}>
                  <AddItemButton
                    text={"Add sensor"}
                    fontSize="12px"
                    fontWeight="600"
                    marginTop="0px"
                    onClick={() => {
                      setShowSensorFields(true);
                    }}
                  />
                </Col>
              </>
            ) : (
              <>
                {/* <div className="w-full flex justify-end">
                  <CloseOutlined
                    onClick={() => {
                      setShowSensorFields(false);
                    }}
                    className="custom-close-icon"
                  />
                </div> */}
                {/* Sensor ID */}
                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Sensor ID"
                    name="sensor_tracking_id"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value.trim() === "") {
                            return Promise.reject(
                              new Error("Only spaces are not allowed")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                      ({ getFieldValue }) => ({
                        validator: (_, value) => {
                          if (getFieldValue("sensor") && !value) {
                            return Promise.reject(
                              new Error("Please enter sensor tracking ID")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomInput
                      placeholder="Paste tracking number"
                      height="36px"
                      width="100%"
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#000"
                      borderRadius="8px"
                      placeholderColor="#5E5E5E"
                      lineHeight="38px"
                    />
                  </Form.Item>
                </Col>
                {/* Sensor Name */}
                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Sensor provider"
                    name="sensor"
                    rules={[
                      ({ getFieldValue }) => ({
                        validator: (_, value) => {
                          if (getFieldValue("sensor_tracking_id") && !value) {
                            return Promise.reject(
                              new Error("Please select sensor")
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <CustomDynamicSelect
                      // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                      placeholder="Select"
                      width="100%"
                      height="36px"
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#000"
                      borderRadius="8px"
                      allowClear={true}
                      isSensor={true}
                      options={sensorsList}
                      label="sensor_name"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            <Divider style={{ margin: "0" }} />
            <Col span={24}>
              <Row gutter={[8, 16]}>
            {/* Reference Number */}
                {/* 14 span when link code added */}
                <Col span={14}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Reference number"
                    name="reference_number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter reference number",
                      },
                      {
                        validator: (_, value) => {
                          // Check if the value is only spaces or empty
                          if (value && value.trim() === "") {
                            return Promise.reject(
                              new Error("Only spaces are not allowed")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <CustomInput
                      placeholder="Your internal reference #"
                      height="36px"
                      width="100%"
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#000"
                      borderRadius="8px"
                      placeholderColor="#5E5E5E"
                      lineHeight="38px"
                    />
                  </Form.Item>
                </Col>
                {/* Link code  */}
                <Col span={10}>
                  <Form.Item
                    className="custom-input form-input-style"
                    name="link_code"
                    label={
                      <Tooltip
                      title={
                        <div
                          style={{
                            textAlign: "center",
                            whiteSpace: "normal",
                            fontSize: "12px",
                            fontWeight: "600",
                            lineHeight: "16px",
                          }}
                        >
                          Will be appended to Reference ID. Helpful in linking shipments 
                        </div>
                      }
                      overlayStyle={{ maxWidth: "154px" }}
                      placement="top"
                    > 
                      <span
                        style={{
                          borderBottom: "1px dotted #000",
                          display: "inline-block",
                        }}
                        >
                        Link code (optional)
                      </span>
                        </Tooltip>
                    }
                    rules={[
                      {
                        required: false,
                        pattern: /^[a-zA-Z0-9]{0,10}$/,
                        message: "Please enter up to 10 alphanumeric",
                      },
                    ]}
                    
                  >
                    <CustomInput
                      placeholder="Code"
                      height="36px"
                      width="100%"
                      border="0px"
                      bgColor="#F3F3F3"
                      textColor="#000"
                      borderRadius="8px"
                      placeholderColor="#5E5E5E"
                      lineHeight="38px"
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            {/* Teams  */}
            {/* <Col span={24}>
              <Form.Item
                className="custom-input"
                label="Team"
                name="teams"
                rules={[{ required: true, message: "Please select team" }]}
              >
                 <TeamsSelector
          teamsOptions={teamsOptions}
          selectedTeams={selectedTeams}
          onChange={setSelectedTeams}
        />
              </Form.Item>
            </Col> */}

            {/* teams  */}
            {hasValidTeams && (
              <>
                <Col span={24}>
                  {/* <CustomParagraph
                    text={`Primary Team`}
                    fontSize={12}
                    fontWeight={600}
                    color="#000"
                    lineHeight={"20px"}
                    marginBottom={8}
                  /> */}

                  {/* <p
  style={{
    fontSize: "12px",
    fontWeight: 600,
    color: "#000",
    lineHeight: "20px",
    marginBottom: "8px",
    display:'flex',
    gap:'4px'
  }}
>
 <span style={{height:'100%',color:'#ff4d4f', fontSize:'18px' , paddingTop:'2px' , opacity:'0.7' , display:'flex' , alignItems:'center'}}>*</span> Primary Team
</p> */}
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Primary Team"
                    name="teams"
                    rules={[{ required: true, message: "Please select team" }]}
                  >
                    {/* <TeamsSelectorCheckbox
                    teamsOptions={allTeams}
                    selectedTeams={selectedTeams}
                    setSelectedTeams={setSelectedTeams}
                    onChange={setSelectedTeams}
                  /> */}
                    <TeamsSelector
                      teamsOptions={allTeams}
                      selectedTeams={selectedTeams}
                      onChange={setSelectedTeams}
                      formState="add"
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {/* Products */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                rules={[
                  {
                    required: false,
                    message: "Please select product",
                  },
                ]}
                // className="custom-input-shipment-product label-13px"
                label="Products"
                name="products"
                //  rules={[{ required: true, message: "Please select product" }]}
              >
                <CustomDynamicSelect
                  className="custom-product-select"
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  mode="multiple"
                  placeholder="Select"
                  width="100%"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  options={productList}
                  allowClear={true}
                />
              </Form.Item>
            </Col>

            {/* Ignore sensor measurement at start */}
            {sensorValue &&
            <Col span={24}>
              <Row>
                <Col span={16}>
                  <div style={{ padding: "8px 0" }}>
                    <CustomCheckboxGroup
                      style={{ fontWeight: "600", fontSize: "14px" }}
                      options={["Ignore sensor measurement at start"]}
                      selectedValues={ignoreSensorAlerts}
                      onChange={setIgnoreSensorAlerts}
                    />
                  </div>
                </Col>
                {ignoreSensorAlerts?.length > 0 && (
                  <Col span={8}>
                    <Flex gap={8} align="center">
                      <CustomParagraph
                        text={"Ignore for"}
                        fontSize={12}
                        fontWeight={400}
                        color="#000"
                        lineHeight={"20px"}
                        marginBottom={0}
                        whiteSpace={"nowrap"}
                      />
                    <Form.Item
                      className="custom-input form-input-style"
                      label=""
                      name="ignore_sensor_measurement_at_start"
                    >

                        <CustomSelect
                          placeholder="Select"
                          height="36px"
                          border="0px"
                          width={'82px'}
                          bgColor="#F3F3F3"
                          textColor="#5E5E5E"
                          borderRadius="8px"
                          options={sensorIgnoreTime}
                          label="courier_name"
                          isCourier={false}
                          allowClear={false}
                        />
                    </Form.Item>
                      </Flex>
                  </Col>
                )}
              </Row>
            </Col>
}
            {/* from location    */}
            <Col span={24}>
              <GoogleMapsProvider>
                <div style={{ display: "flex", gap: "10px" }}>
                  <LocationAutoCompleteShipment
                    form={form}
                    locationList={locationList}
                    handleAddressPlaceSelect={(place) => {
                      handleAddressPlaceSelect(place, "from_location");
                    }}
                    fieldName="from_location"
                    label="Pickup & delivery"
                    width={"90%"}
                    className="custom-input form-input-style"
                    required={true}
                    placeholder="Enter pick-up address/location"
                  />
                  <span style={{ marginTop: "21px" }}>
                    <CustomButton
                      isFormValid={
                        !(selectedLatLng1.lat && selectedLatLng1.lng)
                      }
                      image={EditLocation}
                      iconPosition={"left"}
                      border="none"
                      width="36px"
                      height="36px"
                      borderRadius="50%"
                      bgColor="#f5f5f5"
                      color="#000"
                      boxShadow="none"
                      onClick={() => openMapModal("from_location")}
                      padding={"0"}
                    />
                  </span>
                </div>
              </GoogleMapsProvider>
            </Col>
            {/* to location  */}
            <Col span={24}>
              <GoogleMapsProvider>
                <div style={{ display: "flex", gap: "10px" }}>
                  <LocationAutoCompleteShipment
                    form={form}
                    locationList={locationList}
                    handleAddressPlaceSelect={(place) =>
                      handleAddressPlaceSelect(place, "to_location")
                    }
                    fieldName="to_location"
                    label=""
                    width={"90%"}
                    className="label-13px"
                    placeholder="Enter delivery address/location"
                  />
                  <span style={{ marginTop: "0px" }}>
                    <CustomButton
                      isFormValid={
                        !(selectedLatLng2.lat && selectedLatLng2.lng)
                      }
                      image={EditLocation}
                      iconPosition={"left"}
                      border="none"
                      width="36px"
                      height="36px"
                      borderRadius="50%"
                      bgColor="#f5f5f5"
                      color="#000"
                      boxShadow="none"
                      onClick={() => openMapModal("to_location")}
                      padding={"0"}
                    />
                  </span>
                </div>
              </GoogleMapsProvider>
            </Col>

            {/* map  */}
            {fromLocation && toLocation && (
              <Col span={24}>
                <div className="map-container is-create-shipment-review-map">
                  <GoogleMapsProvider>
                    <ShipmentPreviewMap
                      currentView="summary"
                      fromLocation={fromLocation}
                      fromLatLng={selectedLatLng1}
                      toLocation={toLocation}
                      toLatLng={selectedLatLng2}
                      // lastCoordinates={lastPoint}
                      // shipment={shipment}
                      height={"240px"}
                      isLargeScreen={false}
                    />
                  </GoogleMapsProvider>
                </div>
              </Col>
            )}

            {/* submit buttons  */}
            <div
              style={{
                background: "#fff",
                position: "absolute",
                bottom: "0",
                left: "0",
                width: "100%",
                padding: "0 24px 24px",
              }}
            >
              <CustomButton
                text={"Save"}
                width={"100%"}
                height={48}
                borderRadius={8}
                bgColor={isFormValid ? "#F3F3F3" : "#000"}
                color={isFormValid ? "#A6A6A6" : "#fff"}
                border="0px"
                fontSize={16}
                fontWeight={600}
                // htmlType="submit"
                onClick={() => {
                  form.submit();
                }}
                isFormValid={isFormValid}
              />
              <CustomButton
                key="button1"
                width={"100%"}
                marginTop="8px"
                onClick={() => handleCloseDrawer()}
                text={"Cancel"}
                bgColor="transparent"
                color="black"
                fontSize="16px"
                fontWeight="600"
                boxShadow="none"
                height="48px"
              />
            </div>
          </Row>
        </div>
      </Form>

      {/* Drawer polygon modal  */}
      <CustomModal
        modalOpen={modalOpen}
        setModalOpen={handleSetModalOpen}
        modalTitle={`${modalName}`}
        modalText=""
        modalSize={680}
        buttonText1={"Cancel"}
        buttonText2={"Submit"}
        isFormValid={isFormValid}
        onConfirmClick={onModalConfirm}
      >
        <MapComponent
          onPolygonCompleted={getPolygon}
          selectedLatLng={
            locationName == "from_location" ? selectedLatLng1 : selectedLatLng2
          }
          polygon={locationName == "from_location" ? polygonFrom : polygonTo}
        />
      </CustomModal>
    </>
  );
};

export default CreateShipmentDrawer;
